/* global $, $$ */ /* Bliss */
export class Navigation {
  constructor() {
    this.items = [
      {
        elSelector: '.header__navigation',
        toggleClass: 'nav-is-open',
        toggleSelector: 'data-navigation-toggler',
      },
      {
        elSelector: '.header__login',
        toggleClass: 'login-is-open',
        toggleSelector: 'data-login-toggler',
      },
    ]

    this.setListeners()
    // update position initially
    this.updatePositions()
  }

  setListeners() {
    this.items.forEach(item => {
      $$(`[${item.toggleSelector}]`)._.addEventListener('click', e => {
        e.preventDefault()
        document.body.classList.toggle(item.toggleClass)
        this.updatePositions()
      })
    })

    window.addEventListener('resize', () => {
      this.updatePositions()
    })

    document.body.addEventListener('click', e => {
      this.items.forEach(item => {
        // check if clicked outside
        if (
          !e.target.closest(item.elSelector) &&
          e.target.getAttribute(item.toggleSelector) == null &&
          document.body.classList.contains(item.toggleClass)
        ) {
          this.closeItem(item)
        }
      })
    })

    window.addEventListener('keydown', e => {
      if ((e.key && e.key == 'Escape') || e.keyCode == 27) {
        this.items.forEach(item => {
          this.closeItem(item)
        })
      }
    })
  }

  closeItem(item) {
    document.body.classList.remove(item.toggleClass)
    this.updatePositions()
  }

  updatePositions() {
    this.items.forEach(item => {
      if (document.body.classList.contains(item.toggleClass)) {
        $$(item.elSelector)._.style({top: '0px'})
      } else {
        $$(item.elSelector).forEach(element => {
          element.style.top =
            '-' + ($(item.elSelector).offsetHeight + 50) + 'px'
        })
      }
    })
  }
}
